import { useState } from 'react'
import { Label } from '../Label/Label'
import styles from './Textarea.module.scss'

export interface TextareaProps {
    value: string
    label?: string
    name: string
    tooltip?: string
    onChange: (value: string) => void
    errors?: string[]
    placeholder?: string
}

export const Textarea = ({
    value,
    onChange,
    label,
    name,
    tooltip,
    errors = [],
    placeholder = '',
}: TextareaProps) => {
    const [touched, setTouched] = useState(false)

    return (
        <div>
            <Label for={name} tooltip={tooltip}>
                {label}
            </Label>
            <textarea
                className={styles.textarea}
                value={value}
                onChange={(e) => {
                    onChange(e.target.value)
                }}
                onBlur={() => setTouched(true)}
                placeholder={placeholder}
            ></textarea>
            {touched && !!errors.length && (
                <p className={styles.error}>{errors[0]}</p>
            )}
        </div>
    )
}
